//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.Tables.js";
import "../Diagramming/Diagramming.BaseTaggedObjectBuilder.js";
import "../no/Diagramming.js";
let d=[[[0,"BottomBorder",1,"Diagramming.RenderingPropertiesBuilder",0],[0,"FormattedStringBuilder",0,"Diagramming.FormattedStringBuilder",0],[0,"LeftBorder",1,"Diagramming.RenderingPropertiesBuilder",0],[0,"Locked",1,0],[0,"Padding",1,0],[0,"RightBorder",1,"Diagramming.RenderingPropertiesBuilder",0],[0,"Text",1,0],[0,"TopBorder",1,"Diagramming.RenderingPropertiesBuilder",0]],[[[],"GetCellSettings",{R_:{cellSettings:"Diagramming.Tables.CellSettingsBuilder"}},0,0],[["fileName"],"SetImageFileLocation",{},1,0],[[],"DeleteContent",{},0,0],[[],"DeleteCellSettings",{},0,0],[["numSymbols"],"GetContent",{R_:{symbols:""}},0,0],[["symbols"],"SetContent",{},1,1],[["inheritOption","elementToInheritFrom"],"Inherit",{},2,0],[["strValue","width","height"],"SetSVG",{},3,0]],[]];
SPLM.Diagramming.Tables.CellBuilder = class extends SPLM.Diagramming.BaseTaggedObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.Tables.CellBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.Tables.CellBuilder.InheritOption = Object.freeze({
    "Preferences" : "Preferences", "CustomerDefaults" : "CustomerDefaults", "Selection" : "Selection"});

export default SPLM;